<script lang="ts">
	import type { Snippet } from 'svelte';
	import bibError from '$assets/errors/bib-error.webp';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import Header from '$lib/components/header/Header.svelte';
	import { trackLogoClick } from '$lib/services/tracking/googleAnalytics/tracking';
	import * as m from '$paraglide/messages';

	interface Props {
		title: string;
		children?: Snippet;
	}

	const { title, children }: Props = $props();
</script>

<div class="error-page bg-neutral-weak h-full md:p-2">
	<div>
		<Header
			rightButton={{ label: m.action__back_home(), href: '/' }}
			onLogoClick={trackLogoClick}
		/>
	</div>

	<div class="flex items-center justify-center px-4 md:p-0">
		<div class="flex flex-col gap-4 items-baseline overflow-hidden">
			<Link class="md:hidden" button="ghost" href="/" icon="west" label={m.action__back_home()} />
			<div class="flex flex-col md:flex-row bg-neutral-weakest rd-4 max-w-196">
				<div
					class="px-4 py-8 md:py-0 md:pl-20 md:pr-10 justify-center flex flex-col gap-6 md:gap-8 flex-1"
				>
					<div class="text-title md:text-title-lg">{title}</div>
					<div class="text-text-coloredneutral-softest">
						{@render children?.()}
					</div>
				</div>
				<div class="bg-primary w-full h-43 md:h-86 md:w-64 rd-b-4 md:rd-b-0 md:rd-r-4 relative">
					<img src={bibError} class="absolute bib-error bottom--12 md:bottom-0 w-55" alt="" />
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.error-page {
		display: grid;
		grid-template-rows: auto 1fr;
	}

	.bib-error {
		left: 50%;
		transform: translateX(-50%);
	}

	.error-page :global(header a:last-child) {
		display: none;
	}

	@media screen and (min-width: 960px) {
		.bib-error {
			right: 72px;
			left: unset;
			transform: unset;
		}

		.error-page :global(header a:last-child) {
			display: none;
		}
	}
</style>
